// export const webInfo = {
//     baseUrl: 'https://api.chemistgroup.com.bd',
//     // local: 'http://localhost:3000',
//     // uploadImg:'http://localhost:3000/image/img.jpg'
//     local: 'https://chemist-group-dashboard.vercel.app',
//     uploadImg:'https://chemist-group-dashboard.vercel.app/image/img.jpg',
//     editorKey:"yet4fykrkzy4dbpv6nn5v35atjkzdp8tnke2u1zgzdtm7iga"
// }
export const webInfo = {
    baseUrl: process.env.REACT_APP_BASE_URL,
    // local: 'http://localhost:3000',
    // uploadImg:'http://localhost:3000/image/img.jpg'
    local: process.env.REACT_APP_LOCAL_URL,
    uploadImg:process.env.REACT_APP_IMAGE_URL,
    editorKey:process.env.REACT_APP_TINYEDITOR_TOKEN,
}

